export default __webpack_public_path__ + "static/media/vimeo.ced5c697.svg";